import { NavLink } from "react-router-dom";
import { clsx } from "clsx";
import {
  LayoutDashboard,
  FileText,
  CreditCard,
  CalendarDays,
  ClipboardList,
  Users,
  Wallet,
  CalendarCheck,
  ListTodo,
} from "lucide-react";
import { useAuth } from "../../hooks/useAuth";
import type { PageKey } from "../../types/pages";

interface Tab {
  label: string;
  href: string;
  icon: React.ElementType;
  page?: PageKey;
}

const employeeTabs: Tab[] = [
  { label: "Dashboard", href: "/employee/dashboard", icon: LayoutDashboard, page: "employee:dashboard" },
  { label: "Payslip", href: "/employee/payslip", icon: FileText, page: "employee:payslip" },
  { label: "Loans", href: "/employee/loans", icon: CreditCard, page: "employee:loans" },
  { label: "Leave", href: "/employee/leave", icon: CalendarDays, page: "employee:leave" },
  { label: "Tasks", href: "/employee/tasks", icon: ClipboardList, page: "employee:tasks" },
];

const adminTabs: Tab[] = [
  { label: "Dashboard", href: "/admin/dashboard", icon: LayoutDashboard },
  { label: "Users", href: "/admin/users", icon: Users },
  { label: "Loans", href: "/admin/loans", icon: Wallet },
  { label: "Leave", href: "/admin/leave", icon: CalendarCheck },
  { label: "Tasks", href: "/admin/tasks", icon: ListTodo },
];

export function BottomTabBar() {
  const { isAdmin, hasPageAccess } = useAuth();

  const tabs = isAdmin
    ? adminTabs
    : employeeTabs.filter((t) => !t.page || hasPageAccess(t.page));

  if (tabs.length === 0) return null;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-white border-t border-[#e2e8f0]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      aria-label="Mobile tab navigation"
    >
      <div className="flex h-14">
        {tabs.map(({ label, href, icon: Icon }) => (
          <NavLink
            key={href}
            to={href}
            className={({ isActive }) =>
              clsx(
                "flex flex-1 flex-col items-center justify-center gap-0.5 text-[10px] font-medium transition-colors",
                isActive ? "text-[#2447d9]" : "text-[#94a3b8]",
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  className={clsx(
                    "h-5 w-5 shrink-0",
                    isActive ? "text-[#2447d9]" : "text-[#94a3b8]",
                  )}
                />
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
